import React, { memo } from "react";
import {
  Icon,
  Stack,
  Typography,
  Divider,
  Chip,
} from "investira.react.components";
import { formats } from "investira.sdk";

const PlanoPosicao = memo((props) => {
  const {
    beta,
    created,
    carteira,
    enquadramento,
    consolidacao,
    consolidacao_por_emissor,
    aberta,
  } = props;
  return (
    <Stack
      direction="row"
      gap={1.5}
      alignItems="center"
      sx={{
        flex: 1,
        minWidth: 0,
      }}
    >
      {beta && (
        <>
          <Chip label="Beta" color="warning" size="small" variant="outlined" />
          <Divider orientation="vertical" flexItem />
        </>
      )}
      <Icon iconName="calendar" color="textSecondary" size={16} />
      <Typography variant="caption" color="textSecondary">
        {created && formats.formatDateCustom(created, "DD/MM/YYYY")}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{
          textTransform: "uppercase",
        }}
      >
        {consolidacao_por_emissor === "P" ? consolidacao : carteira}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        {`POSIÇÃO ${aberta ? `ABERTA` : "FECHADA"}`}
      </Typography>
      {enquadramento && (
        <>
          <Divider orientation="vertical" flexItem />
          <Typography variant="caption" color="textSecondary">
            {enquadramento}
          </Typography>
        </>
      )}
      {consolidacao && consolidacao_por_emissor !== "P" && (
        <>
          <Divider orientation="vertical" flexItem />
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              textTransform: "uppercase",
            }}
          >
            Consolidação por emissor: {consolidacao}
          </Typography>
          {/* <Chip size="small" color="primary" label={consolidacao} /> */}
        </>
      )}
    </Stack>
  );
});

export default PlanoPosicao;
